var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{staticClass:"LogoHero",attrs:{"alt":("" + (_vm.heroIcon.description)),"src":require(("@/assets/" + (_vm.heroIcon.icon)))}})])}
var staticRenderFns = []

export { render, staticRenderFns }